<template>
    <section class="mt-10">
        <div class="img-container flex justify-center">
            <img class="footer-img" src="images/footer.png">
        </div>
        <div class="text-center">
            <p class="footer-text"> &copy; 2024 AstroKitty. All rights reserved</p>
            <p class="footer-text">
                AstroKitty is a digital token on Solana. It has no function, utility or instrinsic value. There is no promise or expectation of any financial return or profit.
            </p>
        </div>
    </section>
</template>

<script>
export default {
    name: 'FooterPage'
};
</script>

<style>
.footer-img {
    height: 50vh;
}

.footer-text {
    font-size: 12px;
}
</style>